var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'formik';
import { Spacer } from '../../../../uikit/misc/Spacer';
import Typography from '@mui/material/Typography';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
import { applicantOccupationPageModel } from './formModel';
import { SelectFormikField } from '../../../../components/molecules/FormFields/SelectField';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import constants from './constants';
import { FormikForm } from '../../../../components/molecules/FormikForm';
import { RadioGroupFormikField } from '../../../../components/molecules/FormFields/RadioGroupField';
import { DatepickerFormikField } from '../../../../components/molecules/FormFields/DatepickerField';
import { CurrencyInputFormikField } from '../../../../components/molecules/FormFields/CurrencyInputField';
import ApplicantHead from '../../parts/ApplicantHead';
import { PostalAddressSubForm } from '../../../../subforms/PostalAddressSubForm';
import { FieldBoxHeader } from '../../../../uikit/fields/FieldBox';
import { MAIN_FORM_STEPS } from '../../../../store/mainForm/mainForm.types';
import { MainFormFooter } from '../../../../components/molecules/MainFormFooter';
var validationSchema = applicantOccupationPageModel.validationSchema, selectors = applicantOccupationPageModel.selectors, helpers = applicantOccupationPageModel.helpers, PATHS = applicantOccupationPageModel.paths;
var t = getTranslation(translations);
var mapStateToProps = function (state) { return ({
    initialValues: mainFormSlice.selectors.getApplicantOccupationData(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    goToPrevPage: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.PROJECT_PAGE));
    },
    goToNextPage: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.ADVICE_PAGE));
    },
    goToAdditionalChargeCalculatorPage: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.ADDITIONAL_CHARGE_CALCULATOR_PAGE));
    },
    refuseLeadByPrescoring: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.REFUSED_BY_PRESCORING_SCREEN));
    },
    checkForAdditionalCharge: function () {
        return dispatch(mainFormSlice.actions.checkForAdditionalCharge());
    },
    saveApplicantOccupationData: function (fields) {
        return dispatch(mainFormSlice.actions.saveApplicantOccupationData(fields));
    },
    setApplicantOccupationData: function (fields) {
        return dispatch(mainFormSlice.actions.setApplicantOccupationData(fields));
    },
}); };
export var ApplicantOccupationPage = function (props) {
    var goToPrevPage = props.goToPrevPage, refuseLeadByPrescoring = props.refuseLeadByPrescoring, goToNextPage = props.goToNextPage, goToAdditionalChargeCalculatorPage = props.goToAdditionalChargeCalculatorPage, saveApplicantOccupationData = props.saveApplicantOccupationData, checkForAdditionalCharge = props.checkForAdditionalCharge, setApplicantOccupationData = props.setApplicantOccupationData, initialValues = props.initialValues;
    return (React.createElement(FormikForm, { initialValues: initialValues, validateOnChange: false, validationSchema: validationSchema, onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            var res, isAdditionalChargeRequired;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, saveApplicantOccupationData(values)];
                    case 1:
                        res = _a.sent();
                        actions.setSubmitting(false);
                        if (res && res.data && res.data.rejected) {
                            return [2 /*return*/, refuseLeadByPrescoring()];
                        }
                        return [4 /*yield*/, checkForAdditionalCharge()];
                    case 2:
                        isAdditionalChargeRequired = _a.sent();
                        if (isAdditionalChargeRequired) {
                            return [2 /*return*/, goToAdditionalChargeCalculatorPage()];
                        }
                        goToNextPage();
                        return [2 /*return*/];
                }
            });
        }); } }, function (formik) {
        var values = formik.values;
        var handleBackButtonClick = function () {
            goToPrevPage();
            setApplicantOccupationData(values);
        };
        return (React.createElement(Form, null,
            React.createElement(Typography, { variant: "h3" }, t.title),
            React.createElement(Spacer, { size: 3 }),
            React.createElement(ApplicantHead, { number: 1, count: selectors.APPLICANTS_AMOUNT(values) || 1 }),
            React.createElement(SelectFormikField, { name: PATHS.OCCUPATION_TYPE, label: t.occupationTypeLabel, description: t.occupationTypeDescription, options: constants.occupationTypeOptions }),
            React.createElement(CurrencyInputFormikField, { name: PATHS.INCOME, placeholder: t.incomePlaceholder, label: helpers.getLabelForIncomeField(values), description: helpers.getDescriptionForIncomeField(values) }),
            React.createElement(Spacer, { size: 2 }),
            helpers.shouldShowIsOnProbationPeriod(values) && (React.createElement(React.Fragment, null,
                React.createElement(RadioGroupFormikField, { name: PATHS.IS_ON_PROBATION_PERIOD, label: t.isOnProbationPeriodLabel, options: constants.yesOrNotOptions }),
                helpers.shouldShowOccupationBegin(values) && (React.createElement(DatepickerFormikField, { name: PATHS.OCCUPATION_BEGIN, label: t.occupationBeginLabel })),
                React.createElement(Spacer, { size: 2 }))),
            helpers.shouldShowIsLimitedOccupation(values) && (React.createElement(React.Fragment, null,
                React.createElement(RadioGroupFormikField, { name: PATHS.IS_LIMITED_OCCUPATION, label: t.isLimitedOccupationLabel, options: constants.isLimitedOccupationOptions }),
                helpers.shouldShowOccupationLimitedUntil(values) && (React.createElement(DatepickerFormikField, { name: PATHS.OCCUPATION_LIMIT_UNTIL, label: t.occupationLimitedUntilLabel })),
                React.createElement(Spacer, { size: 2 }))),
            helpers.shouldShowEmployerAddressCountry(values) && (React.createElement(React.Fragment, null,
                React.createElement(RadioGroupFormikField, { name: PATHS.EMPLOYER_ADDRESS_COUNTRY, label: t.employerAddressCountryLabel, options: constants.employerAddressCountryOptions, colProps: { xs: 12, sm: 6 } }),
                React.createElement(Spacer, { size: 2 }))),
            React.createElement(FieldBoxHeader, { label: t.postalAddressBlockLabel }),
            React.createElement(PostalAddressSubForm, { namespace: PATHS.POSTAL_ADDRESS, shouldShowLabels: false }),
            helpers.shouldShowSecondApplicant(values) && (React.createElement(React.Fragment, null,
                React.createElement(ApplicantHead, { number: 2, count: 2 }),
                React.createElement(SelectFormikField, { name: PATHS.SECOND_APPLICANT_OCCUPATION_TYPE, label: t.occupationTypeLabel, description: t.occupationTypeDescription, options: constants.occupationTypeOptions }),
                React.createElement(CurrencyInputFormikField, { name: PATHS.SECOND_APPLICANT_INCOME, placeholder: t.incomePlaceholder, label: helpers.getLabelForSecondApplicantOccupationField(values), description: helpers.getDescriptionForSecondApplicantOccupationField(values) }),
                helpers.shouldShowSecondApplicantPostalAddress(values) && (React.createElement(React.Fragment, null,
                    React.createElement(FieldBoxHeader, { label: t.postalAddressBlockLabel }),
                    React.createElement(PostalAddressSubForm, { namespace: PATHS.SECOND_APPLICANT_POSTAL_ADDRESS, shouldShowLabels: false }))))),
            React.createElement(Spacer, { size: 2 }),
            React.createElement(MainFormFooter, { isForwardDisabled: formik.isSubmitting, onBackwardBtnClick: handleBackButtonClick })));
    }));
};
export default connect(mapStateToProps, mapDispatchToProps)(ApplicantOccupationPage);
